import { List, OrderedSet, Record, Set } from 'immutable';
import { PageId } from 'records/Page';
import { UserEmail } from 'records/User';
import { RFIImpactCategoryKind } from './ImpactCategory';

export interface RawNewRFI {
  projectid: string;
  title: string;
  question: string;
  duedate: number;
  assignees: UserEmail[];
  attachmentcount: number;
  pageids: PageId[];
  submittingname: string;
  submittingemail: string;
  submittingcompany: string;
  distributionlist: string[];
  impactcategory: RFIImpactCategoryKind;
  previousversionid: string;
}

export interface NewRFIData {
  projectid: string;
  title: string;
  question: string;
  duedate: number;
  assignees: List<UserEmail>; // user emails
  attachmentcount: number;
  pageids: Set<PageId>;
  submittingname: string;
  submittingemail: string;
  submittingcompany: string;
  distributionlist: OrderedSet<string>;
  impactcategory: RFIImpactCategoryKind;
  previousversionid: string;
}

const defaultValues: NewRFIData = {
  projectid: '',
  title: '',
  question: '',
  duedate: 0,
  assignees: List(),
  attachmentcount: 0,
  pageids: Set<PageId>(),
  submittingname: '(empty)',
  submittingemail: '(empty)',
  submittingcompany: '(empty)',
  distributionlist: OrderedSet<string>(),
  impactcategory: 'NONE',
  previousversionid: '',
};

export const NewRFIFactory = Record(defaultValues, 'NewRFI');

export class NewRFI extends NewRFIFactory {
  static deserialize(rawNewRFI: RawNewRFI): NewRFI {
    return new NewRFI({
      ...rawNewRFI,
      assignees: List(rawNewRFI.assignees),
      pageids: Set(rawNewRFI.pageids),
      distributionlist: OrderedSet(rawNewRFI.distributionlist),
    });
  }

  serialize(): RawNewRFI {
    return {
      ...this.toJS(),
      assignees: this.assignees.toArray(),
    };
  }
}
